import memoize from 'memoize-one';

import { CenteredOverlay, CardOverlay, TopOverlay } from './Types';

const OverlayTypes = Object.freeze({
  Card: 'card',
  Centered: 'centered',
  Top: 'top',
});

function getProperOverlayType(type) {
  switch (type) {
    case OverlayTypes.Card:
      return CardOverlay;
    case OverlayTypes.Top:
      return TopOverlay;
    case OverlayTypes.Centered:
    default:
      return CenteredOverlay;
  }
}

const getProperOverlayTypeMemoized = memoize(getProperOverlayType);

export { getProperOverlayType, getProperOverlayTypeMemoized, OverlayTypes };
